<template>
  <div id="colorpicker"></div>
</template>

<script>
import XNColorPicker from "./xncolorpicker/xncolorpicker.js";

export default {
  name: "ColorPicker",
  props: {
    value: {
      type: String,
      default:
        "linear-gradient(90.0deg,hsla(94,59%,58%,1) 15.8%,hsla(213,64%,54%,1) 61.9%,hsla(198,100%,53%,1) 99.0%)",
    },
  },
  data() {
    return {
      xncolorpicker: null, // 拾色器实例
    };
  },
  watch: {
    value(val) {
      console.log(this.xncolorpicker.setColor(val));
    },
  },
  mounted() {
    // 初始化拾色器
    this.initColorpicker();
  },
  methods: {
    initColorpicker() {
      const _this = this;
      this.xncolorpicker = new XNColorPicker({
        color: this.value,
        selector: "#colorpicker",
        showprecolor: true, //显示预制颜色
        prevcolors: null, //预制颜色，不设置则默认
        showhistorycolor: false, //显示历史
        historycolornum: 0, //历史条数
        format: "hsla", //rgba hex hsla,初始颜色类型
        showPalette: true, //显示色盘
        show: false, //初始化显示
        lang: "cn", // cn 、en
        colorTypeOption: "linear-gradient", // single,radial-gradient
        alwaysShow: false,
        autoConfirm: true,
        hideInputer: false,
        canMove: true, //选择器位置是否可以拖拽
        hideCancelButton: true,
        hideConfirmButton: true,
        onError: function (e) {},
        onCancel: function (color) {
          // console.log("cancel", color);
        },
        onChange: function (color) {
          _this.$emit("input", color.color.str);
        },
        onConfirm: function (color) {
          // console.log("confirm", color);
          // xncolorpicker.$getCurColor();
        },
      });
    },
  },
  beforeDestroy() {
    // 销毁实例
    this.xncolorpicker.destroy();
    this.xncolorpicker = null;
  },
};
</script>
